export default function concertS3UrlToHttps(s3Url: string, region = 'us-east-1'){
    // only convert if it starts with s3
    if (!s3Url) return s3Url;
    if (!s3Url.startsWith('s3://')) return s3Url;

    const bucketName = s3Url.split('/')[2];
    const key = s3Url.split('/').slice(3).join('/');
    return `https://${bucketName}.s3.${region}.amazonaws.com/${key}`;
}